module.exports = __webpack_public_path__ + "img/Predictive Analysis.95538fbf.png";